import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let webApiUrl = `${process.env.REACT_APP_BASE_URL}air_daily/`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchStationsDaily = createAsyncThunk(
  "stations/fetchStationsDaily",
  () => {
    return axios
      .get(webApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
      .then((response) => response.data);
  }
);
const stationsSlice = createSlice({
  name: "stationsDaily",
  initialState: {
    stationsLoading: true,
    stationsData: {
      SAPA: [],
      ESPS: [],
      OSPM: [],
      SATA: [],
    },
    stationsError: "",
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchStationsDaily.pending,
      (state) => {
        state.stationsLoading = true;
      },
      builder.addCase(
        fetchStationsDaily.fulfilled,
        (state, action) => {
          state.stationsLoading = false;
          state.stationsData = action.payload;
          state.stationsError = "";
        },
        builder.addCase(fetchStationsDaily.rejected, (state, action) => {
          state.stationsLoading = false;
          state.stationsData = [];
          state.stationsError = action.error.message;
        })
      )
    );
  },
});
export default stationsSlice.reducer;
